import {Components} from '@mui/material';

import {Colors} from '@constants/colors.constants';

const tabs: Components = {
  MuiTabs: {
    variants: [
      {
        props: {'aria-label': 'primary'},
        style: {
          '& .MuiTab-textColorPrimary:not(:first-of-type)': {
            marginLeft: 20,
          },
          '.MuiTabs-indicator': {
            height: 4,
          },
          '.MuiTab-root': {
            minHeight: 38,
            minWidth: 'fit-content',
          },
          '.MuiTab-textColorPrimary': {
            fontSize: 18,
            fontWeight: 400,
            padding: 0,
            '&.Mui-selected': {
              color: Colors.text,
              fontWeight: 700,
            },
          },
        },
      },
      {
        props: {'aria-label': 'secondary'},
        style: {
          '& .MuiTab-textColorPrimary:not(:first-of-type)': {
            marginLeft: 20,
          },
          '.MuiTabs-indicator': {
            backgroundColor: Colors.text,
            height: 2,
          },
          '.MuiTab-root': {
            minHeight: 22,
            minWidth: 'fit-content',
            textTransform: 'uppercase',
          },
          '.MuiTab-textColorPrimary': {
            color: Colors.text,
            fontSize: 12,
            fontWeight: 400,
            padding: 0,
            '&.Mui-selected': {
              color: Colors.text,
              fontWeight: 700,
            },
          },
        },
      },
    ],
    styleOverrides: {
      root: {
        minHeight: 0,
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: 'none',
      },
    },
  },
};

export default tabs;
